<template>
    <div>
		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<!-- <span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов найдено: {{this.masObjects_total}}</span> -->
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="billing"
			/>
		</div>
		<div class="d-flex flex-wrap my-3">
			<div class="mr-md-3">
				<h6 class="mb-1">Формирование отчета</h6>	
				<p>Задайте фильтром выше нужные Вам параметры и загрузите отчет в Excel</p>
			</div>
			<base-button   
				@click="reportDownload()" 
				class="btn-simple btn-success my-0" 
			>Скачать <i class="fa fa-file-excel ml-1"></i></base-button>
		</div>	

		<card>
			<div class="row">
				<div class="col-md-7 order-2 order-md-1">
					<ReRentChargeHistory v-model="arrMonthsData"></ReRentChargeHistory>
					<!-- <Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
						:type="'info'" 
						:total="parseInt(masObjects_total)" 
						:perPage="parseInt(10)"
						:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
						:pClick="pClick">
					</Pagination> -->
									
				</div>
				<div class="col-md-5 order-1 order-md-2 mb-3 mb-md-0">
					<ReAddBalance v-model="pay_amount" v-on:refrashrentcharge="refrashrentcharge"></ReAddBalance>
				</div>
			</div>
		</card>
    </div>
</template>
<script>

/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/


import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReAddBalance from 'src/our_components/ReAddBalance.vue';
import ReRentChargeHistory from 'src/our_components/ReRentChargeHistory.vue';
// import Pagination from 'src/our_components/RePagination';

export default {
	name: 'billing-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReFilterBtn,
        ReFilter,
        ReAddBalance,
		ReRentChargeHistory,
		// Pagination,
	},
	data() {
		return {
			ApiData: [],
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			bShowFilter: false,
			masObjects_total: 0,
			pay_amount: '',
			arrMonthsData:[],
			count2page: 10,
		};
	},
	methods: {
		/*
		getApiData(){
			this.$GVO.ApiCall('billing.GET',{flt:{'list':'true'}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.log(errorObjApi));
		},
		*/
		getFilter(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			return filter;
		},
		refrashrentcharge(data){
			this.getApiData();
		},
		getApiData(){

			let filter = this.getFilter();
			this.$GVO.ApiCall('billing.getBill',{flt:{...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.arrMonthsData = [];
					this.masObjects_total = 0;
					// console.log('getApiData',objApi.data);
					for (const strMontgh in objApi.data) {
						if (Object.hasOwnProperty.call(objApi.data, strMontgh)) {
							this.arrMonthsData.push(objApi.data[strMontgh]);
						}
					}
					if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
				}else{
					this.arrMonthsData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.arrMonthsData = []; this.masObjects_total=0; console.error(errorObjApi);});
			
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('billing.GET_FILTER',{})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);	
			this.getApiData();
		},
		INS_RENT(){
			
			this.$GVO.ApiCall('billing.INS_RENT',{'iData':{
				'tar_id':3,
				'comment':'ТЕСТОВАЯ кнопка из интерфейса'
			}})
			.then((objApi) => {
				if(objApi.success){

				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
		},
		reportDownload(){
			const data = {'method':'REPORT_MY_OPERATION',obj:'billing',flt:{...this.getFilter()},tags:''};

			this.$GVO.ApiCall('file',{obj:'reports', data})
			.then((objApi) => { 
				if(objApi.success === true){ console.error(objApi);
					if(typeof objApi.file_path != 'undefined' && objApi.file_path != ''){
						window.open(this.$GVO.endpoint_domen+objApi.file_path, '_blank');
					}
				}else{
					// Выдать ошибку?
				}
			}).catch((errorObjApi) => {console.error(errorObjApi); });			
		}
	},		
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style>
	.ReRentChargeHistory, .ReAddBalance{
		border: 1px solid #01B0E0;
		padding: 15px;
		border-radius: 5px;
	}

</style>
